export const TaskSettingsTabs = {
  QUEUES: 'queues',
  TASK_TAGS: 'tasktags',
  FILE_TAGS: 'filetags',
  ACTIONS: 'actions',
};

export const TaskSettingsTabEntityName = {
  [TaskSettingsTabs.QUEUES]: 'Queue',
  [TaskSettingsTabs.TASK_TAGS]: 'Task Tag',
  [TaskSettingsTabs.FILE_TAGS]: 'File Tag',
  [TaskSettingsTabs.ACTIONS]: 'Template',
};

export const TaskSettingsRoutes = {
  TASK_SETTINGS: 'tasksettings',
  TASK_TEMPLATE_LIST: 'task-template-list',
};

export const InUseLimit = {
  MAX_LIMIT: 'max',
  MIN_LIMIT: 'min',
};

export const InLineEditableListColumns = {
  NAME: 'name',
  ID: 'id',
};
